import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useCategorySlideContext } from "@/components/General/Sidebar/context/categorySlide.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const Back = ({ className }: Props) => {
    const { t } = useGranite();

    const { setClosing } = useCategorySlideContext();

    const handleOnCloseClick = () => {
        setClosing(true);
    };

    return (
        <Button
            color={"link"}
            fullWidth={true}
            onClick={handleOnCloseClick}
            className={cn(
                "tw:px-4 tw:py-2 tw:bg-grey tw:border tw:border-grey-light tw:flex tw:items-center tw:group tw:text-information tw:transition-colors tw:no-underline! tw:rounded-none!",
                "tw:hover:bg-grey-input",
                className
            )}
        >
            <i className={cn("las la-angle-left", "tw:mr-2")} />
            <span className={cn("tw:group-hover:underline")}>
                {t("sideBar.link.productRange.back")}
            </span>
        </Button>
    );
};
